module.exports = __webpack_public_path__ + "static/media/hodl.a05f6921.svg";